var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapsedLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_6737)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181_6737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181_6737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0393 22.4004H9.2793V33.4404H31.0393V22.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1743 16.9415C25.1743 16.9415 16.4138 31.334 12.2962 32.9359C8.17853 34.5377 3.54192 32.4983 1.94002 28.3807C0.338132 24.263 2.37756 19.6263 6.49522 18.0246C10.6129 16.4226 25.1743 16.9415 25.1743 16.9415Z",
    fill: "#FF4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6963 16.7171C14.6963 16.7171 29.3876 16.425 33.4834 18.0819C37.5792 19.7387 39.5564 24.4022 37.8996 28.4981C36.2426 32.5939 31.5792 34.571 27.4834 32.9142C23.3874 31.2574 14.6963 16.7171 14.6963 16.7171Z",
    fill: "#3FD819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9843 24.7998C19.9843 24.7998 11.9844 14.178 11.9844 9.75977C11.9844 5.34149 15.5661 1.75977 19.9843 1.75977C24.4026 1.75977 27.9843 5.34149 27.9843 9.75977C27.9843 14.178 19.9843 24.7998 19.9843 24.7998Z",
    fill: "#FFD541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.722 33.4991C23.7332 32.2092 23.3564 30.9689 22.6741 30.0508C21.9921 29.1327 21.0605 28.6121 20.0845 28.6036C19.1085 28.5951 18.1681 29.0993 17.47 30.0054C16.7721 30.9115 16.3735 32.1451 16.3623 33.435L18.2242 33.4511C18.2298 32.814 18.4266 32.2046 18.7714 31.7569C19.1164 31.3094 19.5809 31.0603 20.0631 31.0644C20.5452 31.0686 21.0053 31.3257 21.3425 31.7793C21.6794 32.2329 21.8657 32.8457 21.8601 33.4828L23.722 33.4991Z",
    fill: "#002BC2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_6737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedLogo);
export default __webpack_public_path__ + "static/media/collapsed_logo.ae7e8a589ef5c1e82923002f7a194ae0.svg";
export { ForwardRef as ReactComponent };